import React, { useEffect, useMemo, useState } from 'react';
import { DatePicker, Button } from 'antd';
import styled from 'styled-components';
import moment from 'moment-timezone';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';

import { FULL_DATE_FORMAT } from '../../../constants/date';

const { RangePicker } = DatePicker;

const StyledPeriod = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: space-between;

  .dates-wrapper {
    width: 295px;
    display: flex;

    .label-period {
      align-items: center;
      font-weight: bold;
      margin-top: 3px;
    }
  }

  .dates {
    font-size: 12px !important;
    display: flex;
    flex-direction: row;
    margin-left: 5px;

    .ant-calendar-picker-input.ant-input {
      font-size: 12px !important;
    }
  }
`;

// изъятие isLast и isLimitExcess, чтобы не пробрасывалось в DOM элемент
// и не кидало warning в консоль
const StyledAddButton = styled(({ isLast, isLimitExcess, ...props }) => <Button {...props} />)`
  margin-left: 5px;
  visibility: ${({ isLast, isLimitExcess }) => {
    return isLast && !isLimitExcess ? 'visible' : 'hidden';
  }};
`;

const StyledDeleteButton = styled(Button)`
  margin-left: 5px;
  border: 1px solid transparent !important;
`;

export const getGlobalDates = (globalFilter, zoneId) => ({
  fromGlobal: moment.tz(globalFilter.from, FULL_DATE_FORMAT, zoneId),
  toGlobal: moment.tz(globalFilter.to, FULL_DATE_FORMAT, zoneId),
});

const getDifference = ({ fromGlobal, toGlobal }) => toGlobal.diff(fromGlobal, 'days');

const Period = ({
  uniqueChar,
  zoneId,
  setPeriod,
  period,
  globalFilter,
  isLast,
  deletePeriod,
  addPeriod,
  isLimitExcess,
}) => {
  // компонент должен отобразится только после того как будут подсчитаны дефолтные значения для периода.
  const isShown = !!(period.from.length && period.to.length);

  const fromDateValue = useMemo(() => moment(period.from), [period]);
  const toDateValue = useMemo(() => moment(period.to).subtract(1, 'day'), [period]);

  const [range, setRange] = useState([fromDateValue, toDateValue]);

  useEffect(() => {
    setRange([fromDateValue, toDateValue]);
  }, [fromDateValue, toDateValue]);

  const onOpenChangeHandler = (isOpen) => {
    if (isOpen) {
      // когда открываем RangePicker, очищаем конечную дату, чтобы она не блочила выбор дат за ее пределами
      setRange([fromDateValue]);
    } else {
      setRange([fromDateValue, toDateValue]);
    }
  };

  const onChangeHandler = ([date]) => {
    const diff = getDifference(getGlobalDates(globalFilter, zoneId));

    setPeriod(
      date.startOf('day').format(FULL_DATE_FORMAT),
      date.add(diff, 'days').startOf('day').format(FULL_DATE_FORMAT)
    );
  };

  return (
    isShown && (
      <StyledPeriod>
        <div className="dates-wrapper">
          <div className="label-period">{uniqueChar}</div>
          <div className="dates">
            <RangePicker
              allowEmpty={[false, true]}
              onChange={onChangeHandler}
              showToday={false}
              value={range}
              disabled={[false, true]}
              allowClear={false}
              onOpenChange={onOpenChangeHandler}
            />
          </div>
        </div>
        <StyledDeleteButton className="square-icon-button" onClick={deletePeriod}>
          <DeleteOutlined />
        </StyledDeleteButton>

        <StyledAddButton
          icon={<PlusOutlined />}
          onClick={addPeriod}
          isLast={isLast}
          isLimitExcess={isLimitExcess}
        />
      </StyledPeriod>
    )
  );
};

export default Period;
